import { LOCALES } from '@marketplace/i18n';

export const confirmModalI18n = {
  [LOCALES.ENG]: {
    confirm_deactivate_message: "Please confirm that you deactivate {appName} application.",
    confirm_activate__message: 'Please confirm that you activate {appName} application.',
    app_page_confirm_register_modal_text:
    // 'Are you sure you want to register {appName} application and get access to the Sandbox?',
    'Are you sure you want to register {appName} application?',
  },
};
